import {
  checkLine,
  formatWhatsAppDirection,
  formatWhatsAppMotorType,
  formatWhatsAppSystemType,
  formatWhatsAppNumber,
  getWhatsAppDefaultIntro,
  getWhatsAppProductType,
  getWhatsAppString,
  line
} from './whatsappMessageStrings';

const buildProductNameLine = (order, language) => {
  const name = order.productName || '';
  const variant = order.productVariant ? ` - ${order.productVariant}` : '';
  return line(getWhatsAppString(language, 'productName'), `${name}${variant}`);
};

// Tek sipariş için WhatsApp mesaj template'i oluştur
export const createSingleOrderWhatsAppMessage = (
  customerInfo,
  order,
  firmaInfo,
  subType = null,
  language = 'tr'
) => {
  if (!customerInfo || !order) {
    return '';
  }

  const wm = (key, params) => getWhatsAppString(language, key, params);
  const quantity = parseInt(order.quantity, 10) || 1;
  const noteLine = order.notes ? `\n📝 *${wm('note')}:* ${order.notes}` : '';
  let orderDetails = '';

  if (order.productType === 'katlamaliPerde' && subType) {
    const usedM2 = parseFloat(order.usedM2) || 0;

    if (subType === 'kumas') {
      orderDetails = `
📦 *${wm('orderDetailFabric')}:*
${buildProductNameLine(order, language).trim()}
${line(wm('usedMeter'), `${formatWhatsAppNumber(usedM2, language)} m`).trim()}
${line(wm('quantity'), quantity).trim()}`;
    } else if (subType === 'mekanizma') {
      orderDetails = `
📦 *${wm('orderDetailMechanism')}:*
${line(wm('productType'), getWhatsAppProductType('katlamaliPerde', language)).trim()}
${line(wm('mechanismType'), order.mechanismType || '').trim()}
${line(wm('quantity'), quantity).trim()}`;
    } else if (subType === 'motor') {
      orderDetails = `
📦 *${wm('orderDetailMotor')}:*
${line(wm('productType'), getWhatsAppProductType('katlamaliPerde', language)).trim()}
${line(wm('motor'), formatWhatsAppMotorType(order.motorType, language) || wm('notSpecified')).trim()}
${line(wm('quantity'), quantity).trim()}`;
    } else if (subType === 'aksesuar') {
      let accLines = '';
      if (Array.isArray(order.accessories) && order.accessories.length > 0) {
        accLines = `\n• ${wm('accessories')}:`;
        order.accessories.forEach((acc) => {
          if (acc.name) accLines += `\n  - ${acc.name} (${acc.quantity} ${wm('quantity')})`;
        });
      } else {
        accLines = `\n• ${wm('accessory')}: ${wm('noAccessoryInfo')}`;
      }
      orderDetails = `
📦 *${wm('orderDetailAccessory')}:${accLines}
${line(wm('quantity'), quantity).trim()}`;
    }
  } else if (order.productType === 'tul' || order.productType === 'kanat') {
    const usedM2 = parseFloat(order.usedM2) || 0;
    const astarLine = order.productType === 'kanat' && order.hasKanatAstar
      ? `\n${line(wm('kanatAstar'), `${order.astarProductName || ''}${order.astarProductVariant ? ` (${order.astarProductVariant})` : ''} — ${formatWhatsAppNumber(order.astarFee || 0, language)} ${wm('currencyTry')}`).trim()}`
      : '';
    orderDetails = `
📦 *${wm('orderDetail')}:*
${buildProductNameLine(order, language).trim()}
${line(wm('usedMeter'), `${formatWhatsAppNumber(usedM2, language)} m`).trim()}${astarLine}
${line(wm('quantity'), quantity).trim()}`;
  } else if (order.productType === 'katlamaliPerde') {
    const usedM2 = parseFloat(order.usedM2) || 0;
    let accLines = '';
    if (Array.isArray(order.accessories) && order.accessories.length > 0) {
      accLines = `\n• ${wm('accessories')}:`;
      order.accessories.forEach((acc) => {
        if (acc.name) accLines += `\n  - ${acc.name} (${acc.quantity} ${wm('quantity')})`;
      });
    } else if (order.accessoryPrice && parseFloat(order.accessoryPrice) > 0) {
      accLines = `\n• ${wm('accessoryFee')}: ${order.accessoryPrice} ${wm('currencyTry')}`;
    }

    const motorLine = order.motorType
      ? line(wm('motor'), formatWhatsAppMotorType(order.motorType, language))
      : '';

    orderDetails = `
📦 *${wm('orderDetail')}:*
${buildProductNameLine(order, language).trim()}
${line(wm('mechanism'), order.mechanismType || '').trim()}
${motorLine.trim()}
${line(wm('usedMeter'), `${formatWhatsAppNumber(usedM2, language)} m`).trim()}${accLines}
${line(wm('quantity'), quantity).trim()}`;
  } else if (order.productType === 'ahsapJaluzi' || order.productType === 'metalJaluzi') {
    const width = parseFloat(order.width) || 0;
    const height = parseFloat(order.height) || 0;
    const yonLine = order.direction ? line(wm('direction'), formatWhatsAppDirection(order.direction, language)) : '';
    const sistemLine = order.sistemTipi ? line(wm('systemType'), formatWhatsAppSystemType(order.sistemTipi, language)) : '';
    const motorLine = order.motorType ? line(wm('motor'), formatWhatsAppMotorType(order.motorType, language)) : '';
    const zigilLine = order.hasZigil ? checkLine(wm('woodenZigil')) : '';
    const reduktorLine = order.hasReduktor ? checkLine(wm('withReducer')) : '';
    const kurdelaLine = order.hasKurdela ? checkLine(wm('withRibbon')) : '';
    const metalZigilLine = order.hasMetalZigil ? checkLine(wm('metalZigil')) : '';
    const metalReduktorLine = order.hasMetalReduktor ? checkLine(wm('metalReducer')) : '';
    const ikiCamLine = order.hasIkiCamArasi ? checkLine(wm('betweenGlass')) : '';

    orderDetails = `
📦 *${wm('orderDetail')}:*
${buildProductNameLine(order, language).trim()}
${line(wm('width'), `${formatWhatsAppNumber(width, language)} cm`).trim()}
${line(wm('height'), `${formatWhatsAppNumber(height, language)} cm`).trim()}${yonLine}${sistemLine}${motorLine}${zigilLine}${reduktorLine}${kurdelaLine}${metalZigilLine}${metalReduktorLine}${ikiCamLine}
${line(wm('quantity'), quantity).trim()}`;
  } else if (order.productType === 'stor' || order.productType === 'zebra') {
    const width = parseFloat(order.width) || 0;
    const height = parseFloat(order.height) || 0;
    const yonLine = order.direction ? line(wm('direction'), formatWhatsAppDirection(order.direction, language)) : '';
    const motorLine = order.motorType ? line(wm('motor'), formatWhatsAppMotorType(order.motorType, language)) : '';

    let jumboLine = '';
    let altEtekDilimLine = '';
    let kapaliKasaLine = '';
    let lazerLine = '';
    let lamaLine = '';
    let kasaLine = '';
    let beyazIsLine = '';

    if (order.productType === 'zebra') {
      jumboLine = order.hasZebraJumbo ? checkLine(wm('jumboSystem')) : '';
      altEtekDilimLine = order.hasZebraAltEtekDilim ? checkLine(wm('bottomHemSlice')) : '';
      kapaliKasaLine = order.hasZebraKapaliKasa ? checkLine(wm('closedCase')) : '';
    } else {
      jumboLine = order.hasStorJumbo ? checkLine(wm('jumboSystem')) : '';
      altEtekDilimLine = order.hasStorAltEtekDilim ? checkLine(wm('bottomHemSlice')) : '';
      kapaliKasaLine = order.hasStorKapaliKasa ? checkLine(wm('closedCase')) : '';
      lazerLine = order.hasStorAltEtekLazer ? checkLine(wm('bottomHemLaser')) : '';
      lamaLine = order.hasStorDekoratifLama ? checkLine(wm('decorativeSlat')) : '';
      kasaLine = order.hasStorDekoratifKasa ? checkLine(wm('decorativeCase')) : '';
      beyazIsLine = order.hasStorAltEtekBeyazIs ? checkLine(wm('bottomHemWhiteWork')) : '';
    }

    orderDetails = `
📦 *${wm('orderDetail')}:*
${buildProductNameLine(order, language).trim()}
${line(wm('width'), `${formatWhatsAppNumber(width, language)} cm`).trim()}
${line(wm('height'), `${formatWhatsAppNumber(height, language)} cm`).trim()}${yonLine}${motorLine}${jumboLine}${altEtekDilimLine}${kapaliKasaLine}${lazerLine}${lamaLine}${kasaLine}${beyazIsLine}
${line(wm('quantity'), quantity).trim()}`;
  } else if (order.productType === 'dikeyPerde' || order.productType === 'dikeyPvc' || order.productType === 'dikeyStor') {
    const width = parseFloat(order.width) || 0;
    const height = parseFloat(order.height) || 0;
    const yonLine = order.direction ? line(wm('direction'), formatWhatsAppDirection(order.direction, language)) : '';
    const motorLine = order.motorType ? line(wm('motor'), formatWhatsAppMotorType(order.motorType, language)) : '';
    const fonLine = order.hasDikeyFon
      ? line(wm('lining'), `${order.dikeyFonName || wm('liningYes')} (${order.dikeyFonCount || 1} ${wm('quantity')})`)
      : '';

    orderDetails = `
📦 *${wm('orderDetail')}:*
${buildProductNameLine(order, language).trim()}${fonLine}
${line(wm('width'), `${formatWhatsAppNumber(width, language)} cm`).trim()}
${line(wm('height'), `${formatWhatsAppNumber(height, language)} cm`).trim()}${yonLine}${motorLine}
${line(wm('quantity'), quantity).trim()}`;
  } else if (order.productType === 'plise') {
    let pliseDetails = `• ${wm('product1')}: ${order.pliseProduct1Name || ''}`;
    if (order.pliseProduct1Variation) {
      pliseDetails += `\n• ${wm('product1Fabric')}: ${order.pliseProduct1Variation}`;
    }
    if (order.pliseCaseVariation) {
      pliseDetails += `\n• ${wm('productCase')}: ${order.pliseCaseVariation}`;
    }

    const hasMultisistem = Array.isArray(order.pliseItems) && order.pliseItems.some((i) => i.multisistem);
    if (order.pliseProduct2Name && hasMultisistem) {
      pliseDetails += `\n• ${wm('product2')}: ${order.pliseProduct2Name}`;
      if (order.pliseProduct2Variation) {
        pliseDetails += `\n• ${wm('product2Fabric')}: ${order.pliseProduct2Variation}`;
      }
    }

    let itemsLine = '';
    if (Array.isArray(order.pliseItems) && order.pliseItems.length > 0) {
      itemsLine = `\n• ${wm('measureList')}:`;
      order.pliseItems.forEach((item, idx) => {
        const ms = item.multisistem ? ` (${wm('multisistem')})` : '';
        itemsLine += `\n  ${idx + 1}. ${item.width} x ${item.height} - ${item.quantity} ${wm('quantity')}${ms}`;
      });
    }

    const globalQty = parseInt(order.quantity, 10) || 1;
    const globalQtyLine = globalQty > 1 ? `\n• ${wm('totalSetQty')}: ${globalQty}` : '';

    orderDetails = `
📦 *${wm('orderDetail')}:*
${pliseDetails}${itemsLine}${globalQtyLine}`;
  } else if (order.productType === 'rustik') {
    const width = parseFloat(order.width) || 0;

    let ayakDetails = `\n• ${wm('legModel')}: ${order.ayakModel || ''}`;
    if (order.ayakCap) ayakDetails += `\n• ${wm('legDiameter')}: ${order.ayakCap}`;
    if (order.ayakUzunluk) ayakDetails += `\n• ${wm('legLength')}: ${order.ayakUzunluk}`;
    if (order.ayakRenkKodu) ayakDetails += `\n• ${wm('colorCode')}: ${order.ayakRenkKodu}`;
    ayakDetails += `\n• ${wm('legCount')}: ${order.ayakSayisi || 0}`;
    if (order.ekAyakSayisi) ayakDetails += ` (+ ${order.ekAyakSayisi} ${wm('extraLegs')})`;

    let extraLines = '';
    if (Array.isArray(order.rustikRaySecenekleri) && order.rustikRaySecenekleri.length > 0) {
      extraLines += `\n\n• ${wm('rayOptions')}:`;
      order.rustikRaySecenekleri.forEach((ray) => {
        if (ray.name) extraLines += `\n  - ${ray.name} (${ray.quantity} cm)`;
      });
    }
    if (Array.isArray(order.rustikAksesuarlar) && order.rustikAksesuarlar.length > 0) {
      extraLines += `\n\n• ${wm('accessories')}:`;
      order.rustikAksesuarlar.forEach((acc) => {
        if (acc.name) extraLines += `\n  - ${acc.name} (${acc.quantity} ${wm('quantity')})`;
      });
    }

    orderDetails = `
📦 *${wm('orderDetail')}:*
${buildProductNameLine(order, language).trim()}
${line(wm('width'), `${formatWhatsAppNumber(width, language)} cm`).trim()}${ayakDetails}${extraLines}
${line(wm('quantity'), quantity).trim()}`;
  } else if (order.productType === 'raySistemi') {
    const width = parseFloat(order.width) || 0;

    orderDetails = `
📦 *${wm('orderDetail')}:*
${buildProductNameLine(order, language).trim()}
${line(wm('width'), `${formatWhatsAppNumber(width, language)} cm`).trim()}
${line(wm('quantity'), quantity).trim()}`;
  } else {
    const width = parseFloat(order.width) || 0;
    const height = parseFloat(order.height) || 0;
    orderDetails = `
📦 *${wm('orderDetail')}:*
${buildProductNameLine(order, language).trim()}
${line(wm('width'), `${formatWhatsAppNumber(width, language)} cm`).trim()}
${line(wm('height'), `${formatWhatsAppNumber(height, language)} cm`).trim()}
${line(wm('quantity'), quantity).trim()}`;
  }

  const message = `${getWhatsAppDefaultIntro(firmaInfo, language)}

👤 *${wm('customer')}:* ${customerInfo.name || ''}
${orderDetails}${noteLine}`;

  return message.trim();
};

// Çoklu sipariş için WhatsApp mesaj template'i oluştur (eski fonksiyon - gerekirse kullanılabilir)
export const createWhatsAppMessage = (customerInfo, orders, firmaInfo, language = 'tr') => {
  if (!customerInfo || !orders || orders.length === 0) {
    return '';
  }

  const wm = (key, params) => getWhatsAppString(language, key, params);
  const locale = language === 'en' ? 'en-US' : 'tr-TR';
  const pieceLabel = language === 'en' ? 'pcs' : 'adet';
  const currencyLabel = language === 'en' ? 'TRY' : 'TL';

  const totalAmount = orders.reduce((sum, order) => {
    const discountedPrice = parseFloat(order.discountedPrice) || 0;
    const totalPrice = parseFloat(order.totalPrice) || 0;
    const qty = parseInt(order.quantity, 10) || 1;
    const orderTotal = discountedPrice > 0 ? discountedPrice : totalPrice;
    return sum + (orderTotal * qty);
  }, 0);

  const orderList = orders.map((order, index) => {
    const productType = getWhatsAppProductType(order.productType, language);
    let quantity = parseInt(order.quantity, 10) || 1;
    if (order.productType === 'plise' && Array.isArray(order.pliseItems) && order.pliseItems.length > 0) {
      quantity = order.pliseItems.reduce((sum, item) => sum + (parseInt(item.quantity, 10) || 0), 0);
    }

    const discountedPrice = parseFloat(order.discountedPrice) || 0;
    const totalPrice = parseFloat(order.totalPrice) || 0;
    const orderPrice = discountedPrice > 0 ? discountedPrice : totalPrice;
    const orderTotal = orderPrice * quantity;

    let productName = order.productName || '';
    if (order.productType === 'plise') {
      productName = order.pliseProduct1Name || '';
      if (order.pliseProduct2Name) productName += ` + ${order.pliseProduct2Name}`;
    } else if (order.productVariant) {
      productName += ` - ${order.productVariant}`;
    }

    return `${index + 1}. ${order.roomName || ''} - ${productType} - ${productName} (${quantity} ${pieceLabel}) - ${orderTotal.toLocaleString(locale)} ${currencyLabel}`;
  }).join('\n');

  const orderDateLabel = language === 'en' ? 'Order Date' : 'Sipariş Tarihi';
  const deliveryDateLabel = language === 'en' ? 'Delivery Date' : 'Teslim Tarihi';
  const customerInfoLabel = language === 'en' ? 'Customer Information' : 'Müşteri Bilgileri';
  const orderDetailsLabel = language === 'en' ? 'Order Details' : 'Sipariş Detayları';
  const totalAmountLabel = language === 'en' ? 'Total Amount' : 'Toplam Tutar';
  const fullNameLabel = language === 'en' ? 'Full Name' : 'Ad Soyad';
  const phoneLabel = language === 'en' ? 'Phone' : 'Telefon';
  const addressLabel = language === 'en' ? 'Address' : 'Adres';

  const message = `🏠 *MEDA FABRIC*

${getWhatsAppDefaultIntro(firmaInfo, language)}

👤 *${customerInfoLabel}:*
${fullNameLabel}: ${customerInfo.name || ''}
${phoneLabel}: ${customerInfo.phone1 || ''}
${addressLabel}: ${customerInfo.address || ''}

📦 *${orderDetailsLabel}:*
${orderList}

💰 *${totalAmountLabel}:* ${totalAmount.toLocaleString(locale)} ${currencyLabel}

📅 ${orderDateLabel}: ${customerInfo.orderDate ? new Date(customerInfo.orderDate?.toDate ? customerInfo.orderDate.toDate() : customerInfo.orderDate).toLocaleDateString(locale) : ''}
🚚 ${deliveryDateLabel}: ${customerInfo.deliveryDate ? new Date(customerInfo.deliveryDate?.toDate ? customerInfo.deliveryDate.toDate() : customerInfo.deliveryDate).toLocaleDateString(locale) : ''}

#MedaFabric #${language === 'en' ? 'Order' : 'Sipariş'}`;

  return message.trim();
};

// WhatsApp URL oluştur (mobil ve web uyumlu)
export const createWhatsAppURL = (phone, message) => {
  if (!phone || !message) {
    return '';
  }

  const cleanPhone = phone.replace(/[^0-9]/g, '');
  const encodedMessage = encodeURIComponent(message);
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const isMac = /Mac|macOS/i.test(navigator.userAgent);
  const shouldUseMobileLink = isMobile || (isTouch && isMac);

  if (shouldUseMobileLink) {
    return `https://wa.me/${cleanPhone}?text=${encodedMessage}`;
  }

  return `https://web.whatsapp.com/send?phone=${cleanPhone}&text=${encodedMessage}`;
};

export const sendSingleOrderWhatsAppMessage = (
  customerInfo,
  order,
  selectedFirma,
  subType = null,
  language = 'tr'
) => {
  if (!selectedFirma || !customerInfo || !order) {
    alert('Lütfen firma seçin ve sipariş bilgilerini kontrol edin.');
    return;
  }

  try {
    const message = createSingleOrderWhatsAppMessage(customerInfo, order, selectedFirma, subType, language);

    if (!message) {
      alert('Mesaj oluşturulamadı. Lütfen bilgileri kontrol edin.');
      return;
    }

    const whatsappURL = createWhatsAppURL(selectedFirma.phone, message);

    if (!whatsappURL) {
      alert('WhatsApp URL oluşturulamadı.');
      return;
    }

    window.open(whatsappURL, '_blank');
  } catch (error) {
    console.error('WhatsApp gönderme hatası:', error);
    alert('WhatsApp mesajı gönderilemedi. Lütfen tekrar deneyin.');
  }
};

export const sendWhatsAppMessage = (customerInfo, orders, selectedFirma, language = 'tr') => {
  if (!selectedFirma || !customerInfo || !orders || orders.length === 0) {
    alert('Lütfen firma seçin ve sipariş bilgilerini kontrol edin.');
    return;
  }

  try {
    const message = createWhatsAppMessage(customerInfo, orders, selectedFirma, language);

    if (!message) {
      alert('Mesaj oluşturulamadı. Lütfen bilgileri kontrol edin.');
      return;
    }

    const whatsappURL = createWhatsAppURL(selectedFirma.phone, message);

    if (!whatsappURL) {
      alert('WhatsApp URL oluşturulamadı.');
      return;
    }

    window.open(whatsappURL, '_blank');
  } catch (error) {
    console.error('WhatsApp gönderme hatası:', error);
    alert('WhatsApp mesajı gönderilemedi. Lütfen tekrar deneyin.');
  }
};
